module.exports = __webpack_public_path__ + "img/user2-160x160.b88fb2c0.jpg";